import { useState, useEffect, useContext } from "react";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { licenseApiUrl, publicConfig } from "@/config/publicConfig";

interface Options {
  method?: string;
  headers?: {
    Accept: string;
    "Content-Type": string;
    Authorization: string;
  };
  data?: any;
}

interface ResponseData {
  attributes: any;
  status: string;
}

interface Response {
  data: ResponseData;
  meta?: any;
}

interface FetchState {
  response: Response | null;
  isLoading: boolean;
  error: any;
  meta: any;
  statusCode: string;
}

type FetchFunction = (options?: Options) => void;

export const useFetchLicense = (
  url: string,
  isBase: boolean = false,
  isImage: boolean = false
): [FetchState, FetchFunction] => {
  const baseUrl: string = licenseApiUrl();
  const baseOption: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [response, setResponse] = useState<Response | null>(null);
  const [meta, setMeta] = useState<any>(null);
  const [statusCode, setStatusCode] = useState<string>('');
  const [options, setOptions] = useState<Options>({});

  const doFetch: FetchFunction = (options = {}) => {
    if (!publicConfig.licensingEnabled) return;
    // @ts-ignore
    setOptions({ ...baseOption, ...options });
    setIsLoading(true);
  };

  useEffect(() => {
    let skipGetResponseAfterDestroy: boolean = false;
    if (!isLoading) {
      return;
    }
    setIsLoading(true);
    axios(baseUrl + url, options)
      .then((res: AxiosResponse) => {
        setStatusCode(String(res.status));
        if (!skipGetResponseAfterDestroy) {
          if (res.status == 204) {
            // @ts-ignore
            setResponse({ data: { status: "ok" } });
          } else {
            setResponse(res.data);
            if (res.data.meta) {
              setMeta(res.data.meta);
            }
          }
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setStatusCode(err.response ? String(err.response.status) : "");
        if (!skipGetResponseAfterDestroy) {
          if (err.response) {
            setError(err.response.data);
          }
          setIsLoading(false);
        }
      });

    return () => {
      skipGetResponseAfterDestroy = true;
    };
  }, [isLoading]);

  return [{ response, isLoading, error, meta, statusCode }, doFetch];
};
